import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import './style.css';

import { LeftMenuNavigator } from '../../components';

import Notícias from './noticias';

const routes = [
  {
    title: 'Notícias',
    link: '',
  },
];

function Noticias() {
  let { path } = useRouteMatch();
  return (
    <div id="emprestimosMain">
      <LeftMenuNavigator title="Notícias" routes={routes} />
      <div id="emprestimosContentContainer">
        <Switch>
          <Route exact path={path}>
            <Notícias />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Noticias;
